/**
 * OrbDocCommunityContributingARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCommunityContributingARDocScreen
 */

import { useOrbDocCommunityContributingARDocScreenLogic } from '@/hooks/traits/useOrbDocCommunityContributingARDocScreenLogic';
import type { OrbDocCommunityContributingARDocScreenConfig } from '@/hooks/traits/useOrbDocCommunityContributingARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCommunityContributingARDocView as OrbDocCommunityContributingARDocViewEntity } from '@app/shared';
import { OrbDocCommunityContributingARDocBodyView } from '@/components/traits/OrbDocCommunityContributingARDocBodyView';
import { OrbDocCommunityContributingARDocFooterView } from '@/components/traits/OrbDocCommunityContributingARDocFooterView';
import { OrbDocCommunityContributingARDocHeaderView } from '@/components/traits/OrbDocCommunityContributingARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCommunityContributingARDocScreenViewProps {
  config?: Partial<OrbDocCommunityContributingARDocScreenConfig>;
}

export function OrbDocCommunityContributingARDocScreenView({ config: propsConfig }: OrbDocCommunityContributingARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCommunityContributingARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCommunityContributingARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCommunityContributingAR" trait="OrbDocCommunityContributingARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCommunityContributingARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCommunityContributingARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCommunityContributingARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCommunityContributingARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCommunityContributingARDocScreenView;
